import { lockScreenScroll } from '../utils/treatment';
import { hideFixedFilter, hideFixedForm } from './actionsForm';

const sidebarFixed = document.querySelector('.sidebar-fixed');
const formMain = document.querySelector('.form-main');
const filterHeader = document.querySelector('.header-filter');
const unitsSelect = document.querySelector('.units-select');

const closeMenu = `
<div class="sidebar-wrapper close-sidebar">
  <i class="icon-icon-fechar"></i>
  <span>Menu</span>
</div>`;

const openMenu = `
<div class="sidebar-wrapper">
  <i class="icon-menu-yamaha"></i>
  <span>Menu</span>
</div>`;

// FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
export function sidebarFixedBehavior(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((target) => {

    target.addEventListener('click', () => {

      if(formMain && formMain.classList.contains('form-content-fixed')) {
        hideFixedForm();
        lockScreenScroll();
      }

      if(filterHeader && filterHeader.classList.contains('filter-header-fixed')) {
        hideFixedFilter();
        lockScreenScroll();
      }

      target.innerHTML === closeMenu
        ? target.innerHTML = openMenu
        : target.innerHTML = closeMenu;

        if(unitsSelect && target.classList.contains('fixed')) {
          sidebarFixed.classList.toggle('fixed');
        }

      sidebarFixed.classList.toggle('d-flex');
      lockScreenScroll();
    });
  });
}

// FUNCTION TO HIDE SIDEBAR FIXED, IF ANOTHER TARGET IS ACTIVE IN DESKTOP
export function hideSidebarFixed(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((target) => {
    target.innerHTML === closeMenu
    ? target.innerHTML = openMenu
    : target.innerHTML = closeMenu;
  });

  sidebarFixed.classList.toggle('d-flex');
}
